import React, { useEffect } from 'react';

import Card from '~/components/Card';
import { Button, Form } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchExclusiveOfferApi, deleteExclusiveOfferApi, toggleExclusiveOfferPublishedStateApi } from './exclusiveOfferSlice.js';
import EditDeleteBtn from '~/components/EditDeleteBtn';
import Datatable from '~/components/Datatable';

function ExclusiveOffer() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { rows } = useSelector((state) => state.shopSaga.exclusiveOffer);

    const columns = React.useMemo(
        () => [
            {
                name: '#',
                selector: (row) => row.id,
                width: '3rem',
            },
            {
                name: 'offer_type',
                selector: (row) => row.offer_type,
                sortable: true,
            },
            {
                name: 'offer_quantity',
                selector: (row) => row.offer_quantity,
                sortable: true,
            },
            {
                name: 'Edit/Remove',
                cell: (row) => (
                    <EditDeleteBtn
                        hasDelete={false}
                        row={row}
                        thunkFunc={deleteExclusiveOfferApi}
                    />
                ),
            },
        ],
        [],
    );

    useEffect(() => {
        if (rows.length > 0) return;
        dispatch(fetchExclusiveOfferApi(navigate));
    }, []);

    return (
        <Card>
            <div className={'d-flex flex-row-reverse'}>
                <Link to={'create'}>
                    <Button className={'bg-info border border-info'}>Create</Button>
                </Link>
            </div>
            <div className="col-sm-12">
                <Datatable
                    columns={columns}
                    rows={rows}
                />
            </div>
        </Card>
    );
}

export default ExclusiveOffer;
//ref: https://codesandbox.io/s/react-bootstrap-formik-pb831?from-embed=&file=/src/form-section-1.js:436-570
/**Notes */
//(1) even though this is reset buttton, don't use type="reset" here as it will cause nested form fields (like FormikArray) unable to be reset to its inital values (I debugged and figured it out).
